import axios from '@/plugins/axios'

export default {
  async MY_ESTICO ({ commit, state }, payload) {
    const data = {
      params: { page: payload },
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.get('estico', data).then((response) => {
        commit('loading')
        resolve(response)
      }).catch((error) => {
        commit('loading')
        reject(error)
      })
    })
  },
  async SHOW_ESTICO ({ commit, state }, payload) {
    const data = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.get('estico/' + payload, data).then((response) => {
        commit('loading')
        resolve(response)
      }).catch((error) => {
        commit('loading')
        reject(error)
      })
    })
  },
  async STORE_ESTICO ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.post('estico', payload, options).then((response) => {
      commit('loading')
      return response
    })
  },
  async UPDATE_ESTICO ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.put('estico/' + payload.param, payload, options).then((response) => {
      commit('loading')
      return response
    })
  },
  async DELETE_ESTICO ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.delete('estico/' + payload, options).then((response) => {
      commit('loading')
      return response
    })
  }
}
